export enum EMicaChat_DireccionMensaje {
  INBOUND = 'INBOUND',
  OUTBOUND = 'OUTBOUND',
}

export enum EMicaChat_EstadoMensaje {
  RECIBIDO = 'RECIBIDO',
  ENVIADO = 'ENVIADO',
  ENTREGADO = 'ENTREGADO',
  LEIDO = 'LEIDO',
  FALLIDO = 'FALLIDO',
}

export enum EMicaChat_TipoMensaje {
  TEXT = 'text',
  IMAGE = 'image',
  VIDEO = 'video',
  AUDIO = 'audio',
  DOCUMENT = 'document',
  STICKER = 'sticker',
  BUTTON = 'button',
	INTERACTIVE = 'interactive',
	TEMPLATE = 'template',
}

export enum EMicaChat_EstadoMensajeMedia {
  NO_APLICA = 'NO_APLICA',
  DESCARGANDO = 'DESCARGANDO',
  DESCARGADO = 'DESCARGADO',
  ERROR_DESCARGA = 'ERROR_DESCARGA',
}

// enums frontend
export interface MicaChatAudioData {
  status: EMicaChat_EstadoMensajeMedia;
  stream_url?: string | null;
  error_message?: string | null;
}
